
// 2. PartnerPermissions.jsx
export const PartnerPermissions = () => {
  const categories = [
    { title: "Receipt Management", actions: ["View All Receipt", "Create Receipt", "Edit Receipt"] },
    { title: "Sales Counter", actions: ["Add Charges", "Add Tax", "Discount"] },
    { title: "Vendor Management", actions: ["Create", "Edit"] },
    { title: "Reports", actions: ["View Reports", "Manage Sales"] },
  ];

  return (
    <div className="min-h-screen p-4">
      <h1 className="text-lg font-bold mb-4">Partner Permissions</h1>
      <div className="space-y-6">
        {categories.map((cat, i) => (
          <div key={i}>
            <p className="font-semibold text-sm mb-2">{cat.title}</p>
            <div className="flex flex-wrap gap-2">
              {cat.actions.map((a, j) => (
                <span key={j} className="bg-primary text-white px-3 py-1 rounded-full text-xs">
                  {a}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

